import { useEffect } from "react";
import styles from "./JobDetails.module.scss";
import editIcon from "../../../../assets/images/edit-icon-outline.svg";
import mailIcon from "../../../../assets/images/email-outline.svg";
import phoneIcon from "../../../../assets/images/phone-outline.svg";
import profileIcon from "../../../../assets/images/profile-icon.svg";
import BlockedIcon from "../../../../assets/images/lockedIcon.svg";
import { message, Select } from "antd";
import { JobDetailsConsts, jobStatusFilterOptions } from "./constants";
import { DatabaseCommonTableProps } from "../../../../Types/DatabaseTabTypes";
import JobDatabaseService from "../../../../services/jobDatabase.service";
import { useHistory, useLocation } from "react-router-dom";
import { ViewListingTypes } from "../../../../enums/ViewListingTypes";
import { useWrapperContext } from "../../../../context/WrapperContext";
import { useMaterials } from "../../../../context/materialListingContext";
import { useTruckDetailContext } from "../../../../context/TruckDetailsContext";
import CreateJobServices from "../../../../services/createJob.services";
import { appRoutes } from "../../../../constants/appRoutes";
import RolesServices from "../../../../services/roles.services";
import { UserRoleActions } from "../../../../enums/UserRolesEnum";
import ConditionalRender from "../../../../reusable-components/ConditionalRender";
import { isEmptyValue } from "../../../../utils/emptyStringCheck";
import dropDownArrow from "../../../../assets/images/customDropDownArrow.svg";
import TNLoader from "../../../../reusable-components/TNLoader";
import { JobStepNumber } from "../../../../Utilities/jobUtil";
import { jobStatus } from "../../../CreateJob/CreateJobView/constants";

const JobDetails = (props?: DatabaseCommonTableProps) => {
  const { sectionId } = props;
  const navigate = useHistory();
  const location = useLocation();
  const { setPrevRecord } = useWrapperContext();
  const { resetTruckMaterial } = useMaterials();
  const { resetTruckDetails } = useTruckDetailContext();
  const { FetchSelectedJob } = CreateJobServices();
  const { FetchJobDetails } = JobDatabaseService();
  const { data: jobData, refetch: refetchJobDetails } = FetchSelectedJob(
    sectionId,
    true
  );
  const { data, refetch, isFetching } = FetchJobDetails(sectionId);
  const {
    jobName,
    jobNumber,
    jobType,
    stageId,
    companyName,
    contact,
    contactEmail,
    contactPhone,
    companyId,
    salesPerson
  } = data?.data ?? {
    jobName: "",
  };

  const userDetails = localStorage.getItem("userDetails");
  const userDetailsJson = JSON.parse(userDetails);
  const userRoleInfo = userDetailsJson?.["userRoleInfo"];
  const userRoleProfileInfo = userDetailsJson?.["userProfile"];
  const { FetchUserRoleDetails } = RolesServices();
  const { data: roleDetails } = FetchUserRoleDetails(userRoleInfo);

  const noActionDropFields = roleDetails
    ? roleDetails?.[0]?.otherData?.[1]?.multiPannel?.[0]?.selectedOptions?.includes(
        UserRoleActions.EDIT
      )
    : true;

  const noCustomerAccess = roleDetails
    ? roleDetails?.[0]?.otherData?.[2]?.multiPannel?.[0]?.selectedOptions?.includes(
        UserRoleActions.ALLOW
      )
    : true;

  const handleEditNavigate = () => {
    setPrevRecord(jobData);
    resetTruckDetails();
    resetTruckMaterial();
    navigate.push(
      `/app/update-trucking-material/${sectionId}#${ViewListingTypes.LIST}`,
      {
        edit: true,
        step: jobData?.stageId === jobStatus.jobLead ? 1 : 2,
        from: location,
        source: appRoutes.JOB_DATABASE,
      }
    );
  };
  const handleCustomerNavigate = () => {
    if (!noCustomerAccess) {
      message.error(JobDetailsConsts?.NO_ACCESS_CUSTOMER_DB);
      return;
    }
    if (!companyId) {
      return;
    }
    navigate.push(`${appRoutes.CUSTOMER_PROFILE}/${companyId}`, {
      customerName: companyName,
    });
  };
  useEffect(() => {
    refetch();
    refetchJobDetails();
  }, [sectionId]);
  return (
    <>
    <TNLoader isLoading={isFetching}/>
    <div className={styles.jobDetailContainer}>
      <div className={styles.topSection}>
        <div className={styles.header}>
          <div className={styles.title}>
            <ConditionalRender
              visible={jobData?.isBlocked}
            >
              <img src={BlockedIcon} alt={JobDetailsConsts.BLOCKED_ICON_ALT}/>
            </ConditionalRender>
            <div className={styles.jobName}>
              {jobNumber}-{jobName}
            </div>
            <div className={styles.jobStatus}>
              <Select
                options={jobStatusFilterOptions}
                value={stageId}
                bordered={false}
                className={styles.CustomSelect}
                dropdownClassName={styles.CustomDropdown}
                suffixIcon={<img src={dropDownArrow} />}
              />
            </div>
          </div>
          <ConditionalRender 
            visible={
              noActionDropFields
              && !!!jobData?.isBlocked
              && jobData?.stageId !== jobStatus.dispatchApproved
            }
          >
            <div className={styles.editButton}>
              <img src={editIcon} onClick={handleEditNavigate} />
            </div>
          </ConditionalRender>
        </div>
        <div className={styles.companyName}>
          <ConditionalRender
            visible={!isEmptyValue(companyName)}
          >
            <div
              className={styles.companyNameBlue}
              onClick={handleCustomerNavigate}
            >
              <span className={styles.grayedTag}>{"• "}</span>
              <span className={styles.jobCustomerNameTag}>{companyName}</span>
            </div>
          </ConditionalRender>
          <ConditionalRender visible={!isEmptyValue(jobType)}>
            <div>
              <span className={styles.grayedTag}>{"• "}</span>
              <span className={styles.jobTypeTag}>{jobType}</span>
            </div>
          </ConditionalRender>
          <ConditionalRender visible={!isEmptyValue(salesPerson)}>
            <div>
              <span className={styles.grayedTag}>{"• "}</span>
              <span className={styles.jobTypeTag}>{salesPerson}</span>
            </div>
          </ConditionalRender>
        </div>
      </div>
      <div className={styles.bottomSection}>
        <div className={styles.bottomSectionContent}>
          <div>
            <img src={profileIcon} />
          </div>
          <ConditionalRender visible={!isEmptyValue(contact)} fallback={"-"}>
            <div className={styles.bottomSectionDetailsTag}>{contact}</div>
          </ConditionalRender>
        </div>
        <div className={styles.bottomSectionContent}>
          <div>
            <img src={mailIcon} />
          </div>
          <ConditionalRender
            visible={!isEmptyValue(contactEmail)}
            fallback={"-"}
          >
            <div className={styles.bottomSectionDetailsTag}>{contactEmail}</div>
          </ConditionalRender>
        </div>
        <div className={styles.bottomSectionContent}>
          <div>
            <img src={phoneIcon} />
          </div>
          <ConditionalRender
            visible={!isEmptyValue(contactPhone)}
            fallback={"-"}
          >
            <div className={styles.bottomSectionDetailsTag}>{contactPhone}</div>
          </ConditionalRender>
        </div>
      </div>
    </div>
    </>
  );
};

export default JobDetails;
